import * as _ from 'lodash';
import { PageBase, PageOptionsBase } from '../../Common/PageBase';
import { DatatableApi, Datatable, DatatableOptions } from '../../Widgets/Datatable'
import { DateTimePickerApi } from '../../Widgets/DateTimePicker';
import { MultiSelectApi } from '../../Widgets/MultiSelect'
import { Utils } from '../../Utils/Utils';
import { StatusMessageHelper } from '../../Utils/StatusMessageHelper';
import { StatusMessage, StatusMessageModel, StatusMessageType } from '../../Widgets/StatusMessage'

var tableDomAssignedGames = "<'row'<'col-sm-6'><'col-sm-6'>>" + "<'row'<'col-sm-12'tr>>" + "<'row'<'col-sm-5'i><'col-sm-7'p>>";

var FILTER_DELIM = '-delim-';
var tableCampaignAssignedOffers = 'tableCampaignAssignedOffers_row_';
const batchSize = 100;

export interface DefaultCampaignPageOptions extends PageOptionsBase {
    dataSwitch: string;
    urlList: string;
    urlGetList: string;
    urlDetail: string;
    urlCount: string;
    urlPost: string;
    iDeferLoading: boolean;
    urlOfferDetail: string;
    localizer: {
        StatusEnabled: string;
        StatusDisabled: string;
        DetailsLink: string;
        SetupLink: string;
    }
}

class FreeRoundBrowseRequest {
    public OfferId: string;
    public CampaignId: string;
    public CustomerId: string;
    public RemoteId: string;
    public CustomerOperationId: string;
    public PlayerRemoteId: string;
    public PlayerName: string;
    public PlayerId: string;
    public CurrencyId: string;
    public CampaignName: string;
    public CampaignRemoteId: string;
    public WinPayMethods: string;
    public WinFrom: string;
    public WinTo: string;
    public RoundsAssignedFrom: string;
    public RoundsAssignedTo: string;
    public RoundsPlayedFrom: string;
    public RoundsPlayedTo: string;
    public PendingSpinsFrom: string;
    public PendingSpinsTo: string;
    public ValidFrom: string;
    public ValidTo: string;
    public Result: string;
    public Status: string;
    public Source: string;
    public LastOfferId: number | null;
    public BatchSize: number;
}

export class DefaultCampaignPage extends PageBase<DefaultCampaignPageOptions> {
    private _runButton: JQuery;
    private _loadMoreButton: JQuery;
    private _resetFilterButton: JQuery;
    private _currentRequest: FreeRoundBrowseRequest;

    private _tableOptions: DatatableOptions;
    private _table: Datatable;
    private _tableId: string;

    private _filterPlayerId: JQuery;
    private _filterPlayerRemoteId: JQuery;
    private _filterRemoteId: JQuery;
    private _filterResult: MultiSelectApi;
    private _filterStatus: MultiSelectApi;
    private _filterCurrency: MultiSelectApi;
    private _filterCampaignId: JQuery;
    private _filterCustomerId: MultiSelectApi;
    private _filterCampaignName: JQuery;
    private _filterCampaignRemoteId: JQuery;
    private _filterWinPayMethods: MultiSelectApi;
    private _filterWinFrom: JQuery;
    private _filterWinTo: JQuery;
    private _filterRoundsAssignedFrom: JQuery;
    private _filterRoundsAssignedTo: JQuery;
    private _filterRoundsPlayedFrom: JQuery;
    private _filterRoundsPlayedTo: JQuery;
    private _filterPendingSpinsFrom: JQuery;
    private _filterPendingSpinsTo: JQuery;
    private _filterValidFromFrom: DateTimePickerApi;
    private _filterValidFromTo: DateTimePickerApi;
    private _filterValidToFrom: DateTimePickerApi;
    private _filterValidToTo: DateTimePickerApi;
    private _filterSource: JQuery;
    private _btnCountResult: JQuery;
    private _totalEntries: JQuery;
    private _checkAll: JQuery;
    private _processing: JQuery;
    private _statusMessage: JQuery;

    private _btnCancelOffersMulti: JQuery;
    private selectedOfferRow: string;

    constructor(options: DefaultCampaignPageOptions) {
        super(options);

        if (options.dataSwitch === "assignedOffers") {
            window['setSelectAllCheckbox'] = this.setSelectAllCheckbox;
            this.run = this.run.bind(this);
            this.loadMore = this.loadMore.bind(this);
            this.resetFilter = this.resetFilter.bind(this);
            this.getCountResult = this.getCountResult.bind(this);
            this.showLoadMoreButton = this.showLoadMoreButton.bind(this);
            this.hideLoadMoreButton = this.hideLoadMoreButton.bind(this);
            this.enableRunButton = this.enableRunButton.bind(this);
            this.checkBoxAll = this.checkBoxAll.bind(this);
            this._options = options;

            this.cancelSelectedOffers = this.cancelSelectedOffers.bind(this);
        }

        if (options.dataSwitch === "assignedGames") {
            var getSetupUrl = (rowData: any): string => (`${options.urlDetail}/${rowData.BetSettingId}`);

            this._tableId = "tableCampaignAssignedGames";
            this._tableOptions = {
                url: this._options.urlList,
                dom: tableDomAssignedGames,
                rowId: 'Id',
                autoWidth: true,
                ordering: false,
                columns: [
                    {
                        data: "GameName",
                        render: (data: any, type: any, rowData: any) =>
                            (`<a id='lnkGameName${rowData.BetSettingId}' href='${getSetupUrl(rowData)}'>${data}</a>`)
                    },
                    {
                        data: "CurrencyCode",
                        render: (data: any, type: any, rowData: any) =>
                            (`<span id='spnGameCurrency${rowData.BetSettingId}'>${data}</span>`)
                    },
                    {
                        data: "CoinCount",
                        render: (data: any, type: any, rowData: any) =>
                            (`<span id='spnGameCoinCount${rowData.BetSettingId}'>${data}</span>`)
                    },
                    {
                        data: "CoinSize",
                        render: (data: any, type: any, rowData: any) =>
                            (`<span id='spnGameCoinSize${rowData.BetSettingId}'>${data}</span>`)
                    },
                    {
                        data: "ValuePerSpin",
                        render: (data: any, type: any, rowData: any) =>
                            (`<span id='spnGameValuePerSpin${rowData.BetSettingId}'>${data}</span>`)
                    }
                ]
            };
        }
    }

    init(): void {
        if (this._options.dataSwitch === "assignedGames") {
            // == create 'new Datatable' instance
            if (Utils.isNullOrUndefined(this._tableOptions))
                return;
            this._table = new Datatable(this._tableId, this._tableOptions);
            return;
        }
        this._btnCancelOffersMulti = Utils.getJQueryById("btnCancelSelected");
        this._filterPlayerId = Utils.getJQueryById('filterPlayerId');
        this._filterCustomerId = new MultiSelectApi('filterCustomerId');
        this._filterPlayerRemoteId = Utils.getJQueryById('filterPlayerRemoteId');
        this._filterRemoteId = Utils.getJQueryById('filterRemoteId');
        this._filterResult = new MultiSelectApi('filterResult');
        this._filterStatus = new MultiSelectApi('filterStatus');
        this._filterCurrency = new MultiSelectApi('filterCurrency');
        this._filterCampaignId = Utils.getJQueryById('_filterCampaignId');
        this._filterCampaignName = Utils.getJQueryById('filterCampaignName');
        this._filterCampaignRemoteId = Utils.getJQueryById('filterCampaignRemoteId');
        this._filterWinPayMethods = new MultiSelectApi('filterWinPayMethods');
        this._filterWinFrom = Utils.getJQueryById('filterWinFrom');
        this._filterWinTo = Utils.getJQueryById('filterWinTo');
        this._filterRoundsAssignedFrom = Utils.getJQueryById('filterRoundsAssignedFrom');
        this._filterRoundsAssignedTo = Utils.getJQueryById('filterRoundsAssignedTo');
        this._filterRoundsPlayedFrom = Utils.getJQueryById('filterRoundsPlayedFrom');
        this._filterRoundsPlayedTo = Utils.getJQueryById('filterRoundsPlayedTo');
        this._filterPendingSpinsFrom = Utils.getJQueryById('filterPendingSpinsFrom');
        this._filterPendingSpinsTo = Utils.getJQueryById('filterPendingSpinsTo');
        this._filterValidFromFrom = new DateTimePickerApi("filterValidFromFrom");
        this._filterValidFromTo = new DateTimePickerApi("filterValidFromTo");
        this._filterValidToFrom = new DateTimePickerApi('filterValidToFrom');
        this._filterValidToTo = new DateTimePickerApi('filterValidToTo');
        this._filterSource = Utils.getJQueryById("filterSource");

        this._runButton = Utils.getJQueryById("btnRunQuery");
        this._runButton.on("click", this.run);
        this._loadMoreButton = Utils.getJQueryById("btnLoadMore");
        this._loadMoreButton.on("click", this.loadMore);
        this._resetFilterButton = Utils.getJQueryById("btnResetFilter");
        this._resetFilterButton.on("click", this.resetFilter);
        this._btnCountResult = Utils.getJQueryById("btnCountResult");
        this._btnCountResult.on("click", this.getCountResult);
        this._totalEntries = Utils.getJQueryById("totalEntries");
        this._checkAll = Utils.getJQueryById("selectAll");
        this._checkAll.on("change", this.checkBoxAll);
        this._processing = Utils.getJQueryById("processing");
        this._statusMessage = Utils.getJQueryById("statusMessageWrapper");
        this._btnCancelOffersMulti.on("click", this.cancelSelectedOffers);
    }

    private run(): void {
        this.disableRunButton();
        let totalEntries = <HTMLSpanElement>this._totalEntries[0];
        totalEntries.innerText = "##";
        this._currentRequest = this.getBrowseRequest();
        let table = this.getTableBody();
        table.innerHTML = "";
        this.sendRequest(this._currentRequest);
    }

    private selectedOffer(id: string): void {
        if (id !== '') {
            $("#tableCampaignAssignedOffers tr").css("background-color", "");
            if (id === this.selectedOfferRow) {
                this.hideAssignedGames();
                this.selectedOfferRow = '';
            } else {
                Utils.getJQueryById(id).css("background-color", "lightblue");
                var itemId = id.replace('tableCampaignAssignedOffers_row_', '');
                $('#divAssignedGames').css("visibility", "visible");
                let widthOffers = $('#pageAssignedOffers').width();
                var games = Utils.getJQueryById('tableCampaignAssignedGames').DataTable();
                games.ajax.url(this._options.urlDetail + '/' + itemId);
                games.draw();
                this.selectedOfferRow = id;
                //Applied to avoid continuous games table width expanding (the table expands every time the data reloaded)
                $('#pageAssignedGames').width(widthOffers);
            }
        }
    }

    private cancelSelectedOffers(e: JQueryEventObject): void {
        e.preventDefault();
        var urlPost = this._options.urlPost;
        var ids = $("input[name='selectedOffer']:checked").map(function () {
            return $(this).val();
        });
        var idsGet = ids.get();
        if (!idsGet || idsGet.length == 0) {
            return;
        }
        var statusMessage = Utils.getJQueryById("statusMessageWrapper");
        let refreshData = this.run;
        $.ajax({
            url: urlPost,
            type: "POST",
            dataType: 'html',
            data: { offerIds: idsGet },
            success: function (data) {
                refreshData();
                statusMessage.html(data);
                StatusMessageHelper.initValidator();
                StatusMessageHelper.initSatusMessage();
            }
        });
    }

    private hideAssignedGames(): void {
        $('#divAssignedGames').css("visibility", "hidden");
    }

    private loadMore(): void {
        this.sendRequest(this._currentRequest);
    }

    private showLoadMoreButton(): void {
        this._loadMoreButton.removeClass("display-none");
    }

    private hideLoadMoreButton(): void {
        this._loadMoreButton.addClass("display-none");
    }

    private disableRunButton(): void {
        this._runButton.attr("disabled", 1);
    }

    private enableRunButton(): void {
        this._runButton.removeAttr("disabled");
    }

    private resetFilter(): void {
        this._filterCustomerId.selectAll();
        this._filterStatus.selectAll();
        this._filterResult.selectAll();
        this._filterCurrency.selectAll();
        this._filterWinPayMethods.selectAll();

        this._filterPlayerId.val('');
        this._filterPlayerRemoteId.val('');
        this._filterRemoteId.val('');
        this._filterWinFrom.val('');
        this._filterWinTo.val('');
        this._filterCampaignId.val('');
        this._filterCampaignName.val('');
        this._filterCampaignRemoteId.val('');
        this._filterWinFrom.val('');
        this._filterWinTo.val('');
        this._filterRoundsAssignedFrom.val('');
        this._filterRoundsAssignedTo.val('');
        this._filterRoundsPlayedFrom.val('');
        this._filterRoundsPlayedTo.val('');
        this._filterPendingSpinsFrom.val('');
        this._filterPendingSpinsTo.val('');

        this._filterValidFromFrom.clearDates();
        this._filterValidFromTo.clearDates();
        this._filterValidToFrom.clearDates();
        this._filterValidToTo.clearDates();

        this._filterSource.val('Live');
    }

    private getCountResult() {
        let request = Utils.isNullOrUndefined(this._currentRequest) ? this.getBrowseRequest() : this._currentRequest;
        let urlCount = this._options.urlCount;
        let totalEntries = <HTMLSpanElement>this._totalEntries[0];
        let processing = this._processing;
        let statusMessage = this._statusMessage
        let displayMessage = this.displayMessage;
        processing.show();
        $.ajax({
            url: urlCount,
            type: "POST",
            dataType: 'html',
            data: { request: request },
            success: function (data) {
                totalEntries.innerText = data;
                processing.hide();
                statusMessage.hide();
            },
            error: function (jqXHR, textStatus, errorThrown) {
                processing.hide();
                displayMessage(jqXHR);
            }
        });
    }

    private sendRequest(request: FreeRoundBrowseRequest) {
        let urlGetList = this._options.urlGetList;
        let urlOfferDetail = this._options.urlOfferDetail;
        let table = this.getTableBody();
        let showLoadMore = this.showLoadMoreButton;
        let hideLoadMore = this.hideLoadMoreButton;
        let enableRunButton = this.enableRunButton;
        let processing = this._processing;
        let statusMessage = this._statusMessage
        let displayMessage = this.displayMessage;
        let totalEntries = <HTMLSpanElement>this._totalEntries[0];
        let btnCancelOffersMulti = this._btnCancelOffersMulti;
        let that = this;
        this.hideAssignedGames();
        processing.show();
        $.ajax({
            url: urlGetList,
            type: "POST",
            dataType: 'html',
            data: { request: request },
            success: function (data) {
                let parsedData = JSON.parse(data);
                let items = parsedData.Items;
                let totalCount = parsedData.FilteredCount;
                if (items.length < batchSize + 1) {
                    hideLoadMore();
                }
                else {
                    request.LastOfferId = items[batchSize].Id;
                    showLoadMore();
                }
                const enabled = ['Completed', 'Canceled'];
                $.each(items, function (index, item) {
                    if (index < batchSize) {
                        let row = table.insertRow(-1);
                        row.style.cursor = 'pointer'
                        row.id = tableCampaignAssignedOffers + item.Id;
                        let cell0 = row.insertCell(0);
                        cell0.innerHTML = `<input name='selectedOffer' value='${item.Id}' type='checkbox' onClick="setSelectAllCheckbox()" />`;
                        let cell1 = row.insertCell(1);
                        cell1.innerHTML = `<b>Offer remote ID: </b><a href="${urlOfferDetail}/${item.Id}">${item.RemoteId}</a>`;
                        let cell2 = row.insertCell(2);
                        cell2.innerHTML = `<b>Player name: </b>${item.PlayerRemoteId}<br/><b>Player ID: </b>${item.PlayerId}`;
                        let cell3 = row.insertCell(3);
                        let css = enabled.indexOf(item.Status) > -1 ? "status-enabled" : "status-disabled";
                        cell3.innerHTML = `<b>Status: </b><span class="${css}">${item.Status}</span>`;
                        let cell4 = row.insertCell(4);
                        cell4.innerHTML = `<b>Awarded: </b>${item.RoundsAssigned}<br/><b>Used: </b>${item.RoundsPlayed}<br/><b>Remaining: </b>${item.PendingSpins}`;
                        let cell5 = row.insertCell(5);
                        cell5.innerHTML = `<b>Win amount: </b>${item.TotalWin} ${item.CurrencyCode ? item.CurrencyCode : ""}<br/><b>Currency: </b>${item.CurrencyCode}`;
                        let cell6 = row.insertCell(6);
                        cell6.innerHTML = `<b style="width: 76px; display: inline-block;">Valid from: </b>${item.ValidFrom}<br/><b style="width: 76px; display: inline-block;">Valid to: </b>${item.ValidTo}`;
                    }
                });

                $('#tableCampaignAssignedOffers').on('click',
                    'tr',
                    (event) => {
                        if (event.target.nodeName !== "INPUT") {
                            var trId = event.target.closest('tr').id;
                            that.selectedOffer(trId);
                        }
                    });

                totalEntries.innerText = totalCount;

                if (request.Source == 'Archive') {
                    btnCancelOffersMulti.attr("disabled", 1);
                } else {
                    btnCancelOffersMulti.removeAttr("disabled");
                }
                processing.hide();
                enableRunButton();
                statusMessage.hide();
            },
            error: function (jqXHR, textStatus, errorThrown) {
                processing.hide();
                enableRunButton();
                displayMessage(jqXHR);
            }
        });
    }

    private displayMessage(jqXHR: JQueryXHR): void {
        var statusMessageWrapper = Utils.getJQueryById("statusMessageWrapper");
        let statusMessageData = <StatusMessageModel>{
            code: "500",
            autoClose: false,
            class: "danger",
            message: "Unexpected error",
            type: StatusMessageType.Error
        };
        var statusMessage = new StatusMessage(statusMessageData);
        statusMessageWrapper.html(statusMessage.getHTMLmessage());
        StatusMessageHelper.initValidator();
        StatusMessageHelper.initSatusMessage();
        statusMessageWrapper.show();
    }

    private getTableBody(): HTMLTableSectionElement {
        return document.getElementById("tableCampaignAssignedOffers").getElementsByTagName("tbody")[0];
    }

    private checkBoxAll(): void {
        var checkboxes = $("input[name='selectedOffer']");
        for (var i = 0; i < checkboxes.length; i++) {
            (<HTMLInputElement>checkboxes[i]).checked = (<HTMLInputElement>this._checkAll[0]).checked;
        }
    }

    private setSelectAllCheckbox(): void {
        var checkboxes = $("input[name='selectedOffer']");
        let selectAll = Utils.getJQueryById("selectAll")[0];
        if (Utils.isNullOrUndefined(selectAll))
            return;
        let allCheckboxesChecked = false;
        for (var i = 0; i < checkboxes.length; i++) {
            allCheckboxesChecked = (<HTMLInputElement>checkboxes[i]).checked;
            if (!allCheckboxesChecked)
                break;
        }
        (<HTMLInputElement>selectAll).checked = allCheckboxesChecked;
    }

    private getBrowseRequest(): FreeRoundBrowseRequest {
        let request = new FreeRoundBrowseRequest();
        request.CustomerId = this._filterCustomerId.isAllSelected() ? '' : this._filterCustomerId.getSelectionValues(FILTER_DELIM);
        request.PlayerId = this._filterPlayerId.val();
        request.PlayerName = this._filterPlayerRemoteId.val();
        request.PlayerRemoteId = this._filterPlayerRemoteId.val();
        request.RemoteId = this._filterRemoteId.val();
        request.CurrencyId = this._filterCurrency.isAllSelected() ? '' : this._filterCurrency.getSelectionValues(FILTER_DELIM);
        request.CampaignId = this._filterCampaignId.val();
        request.CampaignName = this._filterCampaignName.val();
        request.CampaignRemoteId = this._filterCampaignRemoteId.val();
        request.WinPayMethods = this._filterWinPayMethods.isAllSelected() ? '' : this._filterWinPayMethods.getSelectionValues(FILTER_DELIM);
        request.WinFrom = this._filterWinFrom.val();
        request.WinTo = this._filterWinTo.val();
        request.RoundsAssignedFrom = this._filterRoundsAssignedFrom.val();
        request.RoundsAssignedTo = this._filterRoundsAssignedTo.val();
        request.RoundsPlayedFrom = this._filterRoundsPlayedFrom.val();
        request.RoundsPlayedTo = this._filterRoundsPlayedTo.val();
        request.PendingSpinsFrom = this._filterPendingSpinsFrom.val();
        request.PendingSpinsTo = this._filterPendingSpinsTo.val();
        request.ValidFrom = this._filterValidFromFrom.getUnixTimestamp() + FILTER_DELIM + this._filterValidFromTo.getUnixTimestamp();
        request.ValidTo = this._filterValidToFrom.getUnixTimestamp() + FILTER_DELIM + this._filterValidToTo.getUnixTimestamp();
        request.Result = this._filterResult.isAllSelected() ? '' : this._filterResult.getSelectionValues(FILTER_DELIM);
        request.Status = this._filterStatus.isAllSelected() ? '' : this._filterStatus.getSelectionValues(FILTER_DELIM);
        request.BatchSize = batchSize + 1;
        request.Source = this._filterSource.val();
        return request;
    }
}


/** WEBPACK FOOTER **
 ** ./Typescript/Pages/FreeRoundCampaigns/DefaultCampaignPage.ts
 **/